import { render, staticRenderFns } from "./BigQueryTableForm.vue?vue&type=template&id=5aa7be18&"
import script from "./BigQueryTableForm.vue?vue&type=script&lang=js&"
export * from "./BigQueryTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports